import axiosInstance from "../api/axiosConfig";

// export const loginApi = async (data) => {
//   const response = await axiosInstance.post("/admin-auth/login", data);
//   return response.data;
// };
export const loginApi = async (data) => {
  const response = await axiosInstance.post("/admin-auth/login", data);

  return response.data;
};
export const ProfileApi = async (data) => {
  const response = await axiosInstance.post("/admin-auth/profile", data);

  return response.data;
};

// ✅ Fast polling for live game rounds only
// export const getLiveRounds = async () => {
//   const response = await axiosInstance.get("/admin/live-rounds");
//   return response.data;
// };

// export const UserDetailsApi = async (userId) => {
//   const response = await axiosInstance.get(
//     `/admin/user-details/${userId}`
//   );

//   return response.data;
// };
export const AlluserList = async (params = {}) => {
  const response = await axiosInstance.get("/admin/get-all-users", {
    params,
  });

  return response.data;
};

export const ActiveuserList = async (params = {}) => {
  const response = await axiosInstance.get("/admin/get-active-users", {
    params,
  });

  return response.data;
};

export const InActiveUserList = async (params = {}) => {
  const response = await axiosInstance.get("/admin/get-inactive-users", {
    params,
  });

  return response.data;
};

export const EarningsOverview = async (params = {}) => {
  const response = await axiosInstance.get("/admin/earnings-overview", {
    params,
  });
  return response.data;
};

export const getUserById = async (data) => {
  const response = await axiosInstance.post("/admin/user-details", data);
  return response.data;
};

export const deleteUser = async (data) => {
  const response = await axiosInstance.post("/admin/users-delete", data);
  return response.data;
};

export const updateUserStatus = async (data) => {
  const response = await axiosInstance.post("/admin/users-status-update", data);
  return response.data;
};

export const getGameSettings = async () => {
  const response = await axiosInstance.get("/admin/get-game-settings");
  return response.data;
};

export const updateGameSettings = async (data) => {
  const response = await axiosInstance.post(
    "/admin/update-game-settings",
    data,
  );
  return response.data;
};

export const getWalletTrns = async (params = {}) => {
  const response = await axiosInstance.get("/admin/get-wallet-transactions", {
    params,
  });

  return response.data;
};

export const geWintWalletTrns = async (params = {}) => {
  const response = await axiosInstance.get(
    "/admin/get-win-wallet-transactions",
    {
      params,
    },
  );

  return response.data;
};

export const geLosstWalletTrns = async (params = {}) => {
  const response = await axiosInstance.get(
    "/admin/get-loss-wallet-transactions",
    {
      params,
    },
  );

  return response.data;
};
export const getUserWallet = async (data) => {
  const response = await axiosInstance.post("/admin/user-wallet", data);
  return response.data;
};
export const DositPending = async (params) => {
  const response = await axiosInstance.get("/admin/deposit-pending", {
    params,
  });
  return response.data;
};

// ✅ Approve Deposit - POST Method
export const ApprovePending = async (data) => {
  const response = await axiosInstance.post("/admin/deposit-approve", data);
  return response.data;
};

// ✅ Reject Deposit - POST Method
export const RejectPending = async (data) => {
  const response = await axiosInstance.post("/admin/deposit-reject", data);
  return response.data;
};
export const getApprovedDeposits = async (params) => {
  const response = await axiosInstance.get("/admin/deposit-approved-list", {
    params,
  });
  return response.data;
};
export const getRejectedDeposits = async (params) => {
  const response = await axiosInstance.get("/admin/deposit-rejected-list", {
    params,
  });
  return response.data;
};

export const getWithdrawPending = async (params) => {
  const response = await axiosInstance.get("/admin/withdraw-pending", {
    params,
  });

  return response.data;
};
export const getWithdrawApprove = async (params) => {
  const response = await axiosInstance.get("/admin/withdraw-approve-list", {
    params,
  });

  return response.data;
};
export const getWithdrawreject = async (params) => {
  const response = await axiosInstance.get("/admin/withdraw-reject-list", {
    params,
  });

  return response.data;
};

export const withdrawapprovestatuschange = async (data) => {
  const response = await axiosInstance.post("/admin/withdraw-approve", data);
  return response.data;
};

export const withdrawrejectstatuschange = async (data) => {
  const response = await axiosInstance.post("/admin/withdraw-reject", data);
  return response.data;
};

export const getKycPendingList = async (params) => {
  const response = await axiosInstance.get("/admin/kyc-pending-list", {
    params,
  });
  return response.data;
};
export const getKycVerifiedList = async (params) => {
  const response = await axiosInstance.get("/admin/kyc-verified-list", {
    params,
  });
  return response.data;
};
export const getKycRejectList = async (params) => {
  const response = await axiosInstance.get("/admin/kyc-reject-list", {
    params,
  });
  return response.data;
};

export const updateKycStatus = async (data) => {
  const response = await axiosInstance.post("/admin/kyc-verify", data);
  return response.data;
};

export const addUserDepositAmount = async (data) => {
  const response = await axiosInstance.post(
    "/admin/add-user-deposit-amount",
    data,
  );
  return response.data;
};

// api/endpoints.js
// export const userLedger = async (userId) => {
//   const response = await axiosInstance.get(`/admin/user-ledger/${userId}`);
//   return response.data;
// };

// api/endpoints.js
export const userLedger = async (userId, params = {}) => {
  const queryParams = new URLSearchParams();

  // Add all query parameters
  if (params.page) queryParams.append("page", params.page);
  if (params.limit) queryParams.append("limit", params.limit);
  if (params.search) queryParams.append("search", params.search);
  if (params.type) queryParams.append("type", params.type);
  if (params.status) queryParams.append("status", params.status);
  if (params.sortBy) queryParams.append("sortBy", params.sortBy);
  if (params.sortOrder) queryParams.append("sortOrder", params.sortOrder);
  if (params.startDate) queryParams.append("startDate", params.startDate);
  if (params.endDate) queryParams.append("endDate", params.endDate);

  const queryString = queryParams.toString();
  const url = `/admin/user-ledger/${userId}${queryString ? `?${queryString}` : ""}`;

  const response = await axiosInstance.get(url);
  return response.data;
};
// // api/endpoints.js
// export const userLedger = async (userId, params = {}) => {
//     const response = await axiosInstance.post(`/admin/user-ledger/${userId}`, {
//         page: params.page || 1,
//         limit: params.limit || 10
//     });
//     return response.data;
// };

export const Admindashboard = async (params) => {
  const response = await axiosInstance.get("/admin/dashboard", { params });
  return response.data;
};

export const getAdminList = async (params) => {
  const response = await axiosInstance.get("/admin-auth/admin-list", {
    params,
  });
  return response.data;
};

// Add this to your endpoints.js file
export const addAdmin = async (data) => {
  const response = await axiosInstance.post("/admin-auth/add-admin", data);
  return response.data;
};

// Add this to your endpoints.js file
export const deleteAdmin = async (adminId) => {
  const response = await axiosInstance.delete(
    `/admin-auth/delete-admin/${adminId}`,
  );
  return response.data;
};

export const updateAdminStatus = async (data) => {
  const response = await axiosInstance.post(
    "/admin-auth/update-admin-status",
    data,
  );
  return response.data;
};
// Get penalty history
export const getPenaltyHistory = async (params) => {
  const response = await axiosInstance.get("/admin/all-penalty-history", {
    params,
  });
  return response.data;
};

// Get bonus history
export const getBonusHistory = async (params) => {
  const response = await axiosInstance.get("/admin/all-bonus-history", {
    params,
  });
  return response.data;
};
// Get deposit history
export const getDepositHistory = async (params) => {
  const response = await axiosInstance.get("/admin/all-deposit-history", {
    params,
  });
  return response.data;
};
// Get withdraw history
export const getWithdrawHistory = async (params) => {
  const response = await axiosInstance.get("/admin/all-withdraw-history", {
    params,
  });
  return response.data;
};

export const getAviatorGameSettings = async () => {
  const response = await axiosInstance.get("/admin/aviator-game-setting");
  return response.data;
};

export const updateAviatorGameSettings = async (data) => {
  const response = await axiosInstance.post(
    "/admin/update-aviator-game-setting",
    data,
  );
  return response.data;
};

export const getGeneralSettings = async () => {
  const response = await axiosInstance.get("/admin/get-general-setting");
  return response.data;
};

export const updateGeneralSettings = async (data) => {
  const response = await axiosInstance.post(
    "/admin/update-general-setting",
    data,
  );
  return response.data;
};

export const contentAdd = async (data) => {
  const response = await axiosInstance.post("/content/add", data);
  return response.data;
};

export const contentGetAll = async () => {
  const response = await axiosInstance.get("/content/all");
  return response.data;
};

export const contentUpdate = async (type, data) => {
  const response = await axiosInstance.put(`/content/${type}`, data);
  return response.data;
};

export const createmail = async (payload) => {
  const response = await axiosInstance.post("/admin/create-mail", payload);
  return response.data;
};

export const mailList = async (params) => {
  const response = await axiosInstance.get("/admin/list-mails", { params });
  return response.data;
};

export const getMailById = async (id) => {
  const response = await axiosInstance.get(`/admin/view-mails/${id}`);
  return response.data;
};

export const deleteMail = async (id) => {
  const response = await axiosInstance.delete(`/admin/mails-delete/${id}`);
  return response.data;
};

export const userDetails = async (id) => {
  const response = await axiosInstance.get(`/admin/user-details/${id}`);
  return response.data;
};

export const upiList = async (params = {}) => {
  const response = await axiosInstance.get("/admin/upi-list", { params });
  return response.data;
};

export const addUpi = async (data) => {
  const response = await axiosInstance.post("/admin/add-upi", data);
  return response.data;
};

export const updateUpi = async (id, data) => {
  const response = await axiosInstance.put(`/admin/upi-update/${id}`, data);
  return response.data;
};

export const updateUpiStatus = async (id, status) => {
  const response = await axiosInstance.put(`/admin/upi-status-update/${id}`, {
    status,
  });
  return response.data;
};

export const deleteUpi = async (id) => {
  const response = await axiosInstance.delete(`/admin/upi-delete/${id}`);
  return response.data;
};

export const BankAccountList = async (params = {}) => {
  const response = await axiosInstance.get("/admin/bank-account-list", {
    params,
  });
  return response.data;
};

export const addBankAccount = async (data) => {
  const response = await axiosInstance.post("/admin/add-bank-account", data);
  return response.data;
};

export const updateBankAccount = async (id, data) => {
  const response = await axiosInstance.put(
    `/admin/bank-account-update/${id}`,
    data,
  );
  return response.data;
};

export const updateBankAccountStatus = async (id, status) => {
  const response = await axiosInstance.put(
    `/admin/bank-account-status-update/${id}`,
    {
      status,
    },
  );
  return response.data;
};

export const deleteBankAccount = async (id) => {
  const response = await axiosInstance.delete(
    `/admin/bank-account-delete/${id}`,
  );
  return response.data;
};

// ============================================================
// QR SETTING APIs
// ============================================================

export const addQR = async (data) => {
  const response = await axiosInstance.post("/admin/add-qr-setting", data);
  return response.data;
};

export const QrList = async () => {
  const response = await axiosInstance.get("/admin/qr-setting-list");
  return response.data;
};

export const updateQr = async (id, formData) => {
  const response = await axiosInstance.put(
    `/admin/qr-setting-update/${id}`,
    formData,
  );
  return response.data;
};

export const updateQrStatus = async (id, status) => {
  const response = await axiosInstance.put(
    `/admin/qr-setting-status-update/${id}`,
    { status },
  );
  return response.data;
};

export const deleteQr = async (id) => {
  const response = await axiosInstance.delete(`/admin/qr-setting-delete/${id}`);
  return response.data;
};

export const depositChfsList = async (params) => {
  const response = await axiosInstance.get("/admin/deposit-chfs-list", {
    params,
  });
  return response.data;
};

export const addDepositChfs = async (data) => {
  const response = await axiosInstance.post("/admin/add-deposit-chfs", data);
  return response.data;
};

export const updateDepositChfs = async (id, data) => {
  const response = await axiosInstance.put(
    `/admin/deposit-chfs-update/${id}`,
    data,
  );
  return response.data;
};

export const updateDepositChfsStatus = async (id, status) => {
  const response = await axiosInstance.put(
    `/admin/deposit-chfs-status-update/${id}`,
    { status },
  );
  return response.data;
};

export const deleteDepositChfs = async (id) => {
  const response = await axiosInstance.delete(
    `/admin/deposit-chfs-delete/${id}`,
  );
  return response.data;
};
